// VendorDashboardPage.duck.js

import { freshPickValidator } from '../../util/freshPickValidator';

// ================ Action types ================ //

export const SET_FRESH_PICK_DATA = 'app/vendorDashboardPage/SET_FRESH_PICK_DATA';

// ================ Reducer ================ //

const initialState = {
  freshPickData: {}
};

export default function vendorDashboardPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {

    case SET_FRESH_PICK_DATA:
      return { freshPickData: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setFreshPickData = (payload) => ({
  type: SET_FRESH_PICK_DATA,
  payload
});

// ================ Page Load ================ //

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const providerId = getState().user?.currentUser?.id?.uuid;

  if (providerId) {
    const freshPickData = await freshPickValidator({ sdk, providerId });
    dispatch(setFreshPickData(freshPickData));
  }
};
